export default __webpack_public_path__ + "static/media/optionsIcon.6626cd71.svg";